export default "__VITE_ASSET__aUEl7pgV__"